import styled from 'styled-components';

import { MediaQuery } from '../../../constants/Styles';

export const Wrapper = styled.div`
  margin-top: 30px;

  ${MediaQuery.M_AND_DOWN} {
    padding: 0 15px;
  }
`;
